'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosList = function IoIosList(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 5h30v30h-30v-30z m6.3 23.8c0.7 0 1.2-0.6 1.2-1.3s-0.5-1.2-1.2-1.2-1.3 0.5-1.3 1.2 0.5 1.3 1.3 1.3z m0-7.5c0.7 0 1.2-0.6 1.2-1.3s-0.5-1.2-1.2-1.2-1.3 0.5-1.3 1.2 0.5 1.3 1.3 1.3z m0-7.5c0.7 0 1.2-0.6 1.2-1.3s-0.5-1.2-1.2-1.2-1.3 0.5-1.3 1.2 0.5 1.3 1.3 1.3z m18.7 14.3v-1.2h-15v1.2h15z m0-7.5v-1.2h-15v1.2h15z m0-7.5v-1.2h-15v1.2h15z' })
        )
    );
};

exports.default = IoIosList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-list.js
// module id = 2678
// module chunks = 168707334958949